import styled, { css } from 'styled-components';
import DispatchingList, { DispatchingListEmpty } from './component';

const styledList = css`
  width: 100%;
  overflow-y: auto;

  &__no-results {
    color: var(--grey700);
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    flex-direction: column;

    &.reduced {
      width: 370px;
      position: relative;
    }

    .title {
      margin-top: 8px;
      font-size: 18px;
      margin-bottom: 16px;
    }
  }

  &.reduced {
    width: 370px;
  }
`;

export default styled(DispatchingList)`
  ${styledList}
`;

const StyledDispatchingListEmpty = styled(DispatchingListEmpty)`
  ${styledList}
`;

export { StyledDispatchingListEmpty };
